import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const Footer = ({ openLead }) => (
  <footer data-testid="site-footer" className="bg-walnut py-24 text-cream lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-ochre">
          Ready when you are
        </p>
        <button
          data-testid="footer-demo-button"
          onClick={openLead}
          className="group mt-8 inline-flex items-end gap-4 font-serif text-5xl font-medium italic leading-none tracking-tight text-cream transition-colors duration-300 hover:text-terracotta sm:text-6xl lg:text-7xl"
        >
          Request a Sample Recap
          <ArrowUpRight className="h-10 w-10 text-terracotta transition-transform duration-300 group-hover:-translate-y-2 group-hover:translate-x-2 lg:h-14 lg:w-14" />
        </button>
      </Reveal>

      <div className="mt-20 flex flex-col gap-6 border-t border-cream/15 pt-8 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-2.5">
          <img
            src="/logo.jpg"
            alt="The Quarterly Pulse logo"
            className="h-8 w-8 rounded-full object-cover"
          />
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-cream/60">
            © 2026 The Quarterly Pulse LLC. All rights reserved.
          </span>
        </div>
        <div className="flex items-center gap-8">
          <a
            data-testid="footer-cancellation-link"
            href="#/cancellation"
            className="text-sm text-cream/60 transition-colors duration-300 hover:text-cream"
          >
            Cancellation Policy
          </a>
          <a
            data-testid="footer-privacy-link"
            href="#/privacy"
            className="text-sm text-cream/60 transition-colors duration-300 hover:text-cream"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  </footer>
);
